import React from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox, { type CheckboxProps } from '@mui/material/Checkbox';

interface Props extends Pick<CheckboxProps, 'disabled'> {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
}

const Checkbox: React.FC<Props> = ({ label, value, onChange, disabled, labelPlacement }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    return (
        <FormControlLabel
            sx={{userSelect: 'none'}}
            label={label}
            labelPlacement={labelPlacement}
            control={
                <MuiCheckbox
                    checked={value}
                    onChange={handleChange}
                    disabled={disabled}
                />
            }
        />
    );
};

export default Checkbox;
